import { ExtractionItem } from "src/app/core/services/property-extraction.service";

export interface AiOption {
  id: number;
  label: string;
  group?: string | null;
  groupId?: number | null;
}

/** Listas do formulário do imóvel, já no formato que os editores usam. */
export interface AiLookups {
  propertyTypes: AiOption[];
  conditions: AiOption[];
  energyClasses: AiOption[];
  divisions: AiOption[];
  nearby: AiOption[];
  units: AiOption[];
  characteristics: AiOption[];
}

/** Valores atuais do formulário, para mostrar o que a extração vai substituir. */
export interface AiCurrentValues {
  details: { [control: string]: any };
  address: { [control: string]: any };
  areasNearby: { [control: string]: any };
}

export type AiEditorKind =
  | "catalog"
  | "number"
  | "date"
  | "boolean"
  | "text"
  | "readonly";

export type AiConfidenceLevel = "high" | "mid" | "low" | "none";

export interface AiAlternativeRow {
  id: number;
  value: any;
  label: string;
  documentId: number | null;
  documentName: string | null;
  page: number | null;
  snippet: string | null;
  confidencePct: number | null;
  conflicting: boolean;
}

export interface AiFieldRow {
  item: ExtractionItem;
  labelKey: string;
  editor: AiEditorKind;
  options: AiOption[];
  /** Valor em edição (id de catálogo, número, data, texto, booleano). */
  value: any;
  /** Valor lido pelo modelo, para "restaurar valor lido". */
  readValue: any;
  readLabel: string;
  unit: string | null;
  accepted: boolean;
  edited: boolean;
  confidenceLevel: AiConfidenceLevel;
  confidencePct: number | null;
  documentName: string | null;
  issues: string[];
  /** O formulário já tem um valor diferente neste controlo. */
  overwrites: boolean;
  currentLabel: string | null;
  alternatives: AiAlternativeRow[];
  showAlternatives: boolean;
}

export interface AiItemRow {
  item: ExtractionItem;
  /** Conteúdo em edição (cópia do que foi lido). */
  data: any;
  accepted: boolean;
  confidenceLevel: AiConfidenceLevel;
  confidencePct: number | null;
  documentName: string | null;
  /** Falta alguma coisa para o item poder ser aplicado. */
  blocked: boolean;
  blockedKey: string | null;
  areasText: string;
}

export interface AiFieldSection {
  key: string;
  titleKey: string;
  icon: string;
  rows: AiFieldRow[];
  accepted: number;
  collapsed: boolean;
}

export interface AiDocumentRow {
  id: number;
  fileName: string;
  typeKey: string;
  status: string;
  readable: boolean;
  failed: boolean;
  processing: boolean;
  summary: string | null;
  error: string | null;
  propertyDocumentTypeId: number | null;
  attachToProperty: boolean;
  canAttach: boolean;
  billedCredits: number;
  isHandwritten: boolean;
  dirty: boolean;
}

export function confidenceLevel(
  confidence: number | null | undefined,
  thresholds: { autoAccept: number; review: number },
): AiConfidenceLevel {
  if (confidence === null || confidence === undefined) return "none";
  if (confidence >= thresholds.autoAccept) return "high";
  if (confidence >= thresholds.review) return "mid";
  return "low";
}

export function confidencePct(confidence: number | null | undefined): number | null {
  if (confidence === null || confidence === undefined) return null;
  return Math.round(Number(confidence) * 100);
}
